// 장치 헬퍼

// =================================================================================================
// 가져오기
// =================================================================================================
// 고정 영역

// 동적 영역
import { Dimensions, Platform } from 'react-native';

// =================================================================================================
// 상수
// =================================================================================================
// 장치 폭
const getWidth = () => {
  return Dimensions.get('window').width;
};
// 장치 높이
const getHeight = () => {
  return Dimensions.get('window').height;
};

// 플랫폼 OS 겟 {ios, android, web}
const getOS = () => {
  return Platform.OS;
};

// =================================================================================================
// 내보내기
// =================================================================================================
export default {
  getHeight,
  getOS,
  getWidth,
};
